import React from 'react';
import { CheckCircle2, Package } from 'lucide-react';
import { BrandSmartImportResponseData } from '../../services/brandsmart.api';

interface Props {
  result: BrandSmartImportResponseData | null;
  onViewAssets: () => void;
}

export default function LocateStep5Done({ result, onViewAssets }: Props) {
  return (
    <div className="flex flex-col items-center text-center space-y-6 py-6">
      <div className="h-16 w-16 rounded-full bg-green-100 flex items-center justify-center">
        <CheckCircle2 className="h-9 w-9 text-green-600" />
      </div>

      <div>
        <h2 className="text-xl font-semibold">All done!</h2>
        {result && (
          <p className="text-sm text-muted-foreground mt-1">
            {result.importedCount} item{result.importedCount !== 1 ? 's' : ''} added to your
            inventory
            {result.newHomesCreated > 0 &&
              ` · ${result.newHomesCreated} new home${result.newHomesCreated !== 1 ? 's' : ''} created`}
            .
          </p>
        )}
      </div>

      {/* Asset list preview */}
      {result && result.assets.length > 0 && (
        <div className="w-full border rounded-xl divide-y bg-card">
          {result.assets.map((a) => (
            <div key={a.id} className="flex items-center gap-3 px-4 py-3">
              <div className="h-8 w-8 rounded-md bg-muted flex items-center justify-center flex-shrink-0">
                <Package className="h-4 w-4 text-muted-foreground" />
              </div>
              <span className="text-sm font-medium truncate">{a.name}</span>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={onViewAssets}
        className="w-full bg-primary text-primary-foreground rounded-lg px-4 py-3 text-sm font-medium"
      >
        View My Assets
      </button>
    </div>
  );
}
